import { ZipProjectActionsEnum, ZipProjectAction } from "./interfaces";
import { ZipContextState } from "./interfaces/zipContextState";

export const zipProjectReducer: React.Reducer<ZipContextState, ZipProjectAction> = (state, action) => {
  switch (action.type) {
    case ZipProjectActionsEnum.ApplyFilters:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeChangedGapsFilter:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeCheckbox:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeCompareToProjectRunConfiguration:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeExcludeZeroMembership:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeFilter:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangePage:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeMemberships:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangePerspectiveZipClass:
    case ZipProjectActionsEnum.ChangePerspectiveZipCode:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeProjectStatus:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeProjectRunConfiguration:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ClickSpecialtyGroupOrZipCode:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.EditProject:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.EditTimeslicePublishComment:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.Error:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.FinishProcessingException:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.LoadedFeatureFlags:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.Loading:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.LoadProjectWithoutRunConfiguration:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ChangeNcpProjectRunStatus:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.PublishProjectRunConfiguration:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.NavigateHistory:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.RenderedMarketProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.RenderedNetworkProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.RenderedProspectProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ResetFilters:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.SortTable:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.StartProcessingException:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.StartRunProject:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.SubmitSpecialtyExceptions:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    case ZipProjectActionsEnum.ProcessProviderChanges:
    case ZipProjectActionsEnum.UpdatedUnprocessedProviders:
      return Object.freeze({
        ...state,
        ...action.payload,
      });
    default:
      return state;
  }
}